import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getSMarketsAsUnits = async (): Promise<IGetSMarketsAsUnits[]> => {
  return axiosDefaultApi.get(`/api/SMarkets/GetSMarketsAsUnits`);
};

type QueryFnType = typeof getSMarketsAsUnits;

type UseGetSMarketsAsUnitsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetSMarketsAsUnits = ({ config }: UseGetSMarketsAsUnitsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getSMarketsAsUnits'],
    queryFn: () => getSMarketsAsUnits(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};

interface IGetSMarketsAsUnits {
	id: number;
	label: string;
}